module.exports = __webpack_public_path__ + "img/schema-1_2x.5da24a79.webp";